import { Language } from '@/api/types';

export const PRIMARY_LANGUAGES: Language[] = ['english', 'spanish'];

export const LANGUAGE_LABEL: Record<Language, string> = {
  english: 'English',
  spanish: 'Español',
  russian: 'Русский',
  ukrainian: 'Українська',
};

export const LANGUAGE_SHORT_CODE: Record<Language, string> = {
  english: 'EN',
  spanish: 'ES',
  russian: 'RU',
  ukrainian: 'UA',
};

const LANGUAGE_ORDER: Record<Language, number> = {
  english: 0,
  spanish: 1,
  russian: 3,
  ukrainian: 2,
};

export const normalizeLanguages = (
  languages: ReadonlyArray<Language>
): Language[] => {
  return [...new Set(languages)].sort(
    (left, right) => LANGUAGE_ORDER[left] - LANGUAGE_ORDER[right]
  );
};

export const splitPrimaryAndSecondaryLanguages = (
  languages: ReadonlyArray<Language>
) => {
  const normalized = normalizeLanguages(languages);
  const primary = normalized.filter((lang) => PRIMARY_LANGUAGES.includes(lang));
  const secondary = normalized.filter(
    (lang) => !PRIMARY_LANGUAGES.includes(lang)
  );

  return [primary, secondary] as const;
};

export const getAutoSelectLanguage = ({
  availableLanguages,
  languageFromParams,
}: {
  availableLanguages: ReadonlyArray<Language>;
  languageFromParams?: Language | null;
}) => {
  if (
    languageFromParams &&
    availableLanguages.includes(languageFromParams)
  ) {
    return languageFromParams;
  }

  if (availableLanguages.length === 1) {
    return availableLanguages[0];
  }

  return null;
};
